export enum CareLinePriorityStatusEnum {
    suspeita = 1,
    confirmado = 2,
    negado = 3
}